
//月份
const monthOptions =  [
	{ name: '1月', value: '1'},
	{ name: '2月', value: '2'},
	{ name: '3月', value: '3'},
	{ name: '4月', value: '4'},
	{ name: '5月', value: '5'},
	{ name: '6月', value: '6'},
	{ name: '7月', value: '7'},
	{ name: '8月', value: '8'},
	{ name: '9月', value: '9'},
	{ name: '10月', value: '10'},
	{ name: '11月', value: '11'},
	{ name: '12月', value: '12'},
];

//投保人证件类型
const companyIdTypeOptions =  [
	{ name: '组织机构代码', value: '01'},
	{ name: '税务登记证', value: '02'},
	{ name: '工商营业执照', value: '04'},
	{ name: '其他', value: '99'}
];

//营业性质
const YYXZOptions =  [
	{ name: "零售", value: "30"},
	{ name: "办公室", value: "31"},
	{ name: "咨询服务（非金融）", value: "32"},
	{ name: "手表维修", value: "35"},
	{ name: "皮具成衣洗护", value: "36"},
	{ name: "餐饮", value: "37"},
	{ name: "美容美发丽人", value: "38"},
	{ name: "文化类培训", value: "40"},
	{ name: "宠物店", value: "41"},
	{ name: "影吧（300平以下", value: "49"},
	{ name: "歌吧（300平以下）", value: "50"},
	{ name: "室内电玩游艺", value: "44"},
	{ name: "幼教（不含游泳）", value: "45"},
	{ name: "舞蹈瑜伽", value: "46"},
	{ name: "室内儿童游乐", value: "47"},
	{ name: "便利超市（300平以下）", value: "51"},
	{ name: "电影院（300平以上）", value: "43"},
	{ name: "KTV（300平以上）", value: "42"},
	{ name: "超市（300平以上）", value: "48"},
	//----------------新加的
	{ name: "家居设计", value: "52"},
	{ name: "摄影工作室", value: "53"},
	{ name: "桌游棋牌室", value: "54"},
	{ name: "保健按摩", value: "55"},
	{ name: "健身房（不含游泳）", value: "56"},
	{ name: "密室逃脱", value: "57"},
	{ name: "蹦床", value: "58"},
];





module.exports = {
	monthOptions,
	companyIdTypeOptions,
	YYXZOptions,
}